import Endpoints from '../../constants/Endpoints';
import axios from '../axiosInstance';
import { ApiResult } from '../types';

const getAll = async (params: any) => {
  const { page, pageSize, ...rest } = params;

  const config = {
    params: { ...rest, offset: page * pageSize, limit: pageSize },
  };

  return await axios.get<never, ApiResult<any>>(Endpoints.TransactionRequest.GetAllV2, config);
};

const getExport = async (params: any) => {
  const { pageSize, page, ...rest } = params;

  const payload = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
  };
  return await axios.get<any, ApiResult<any>>(Endpoints.TransactionRequest.ExportV2, payload);
};

const getTransactionOperations = async (params: { requestId: number }) => {
  const payload = {
    params,
  };
  return await axios.get<any, ApiResult<any>>(
    Endpoints.TransactionRequest.TransactionOperations,
    payload
  );
};

const getApprovalHistory = async ({ id }: { id: string }) => {
  return await axios.get<any, ApiResult<any>>(Endpoints.TransactionRequest.GetApprovalHistory, {
    params: { requestId: id },
  });
};

const reject = async (params: any, config?: any) => {
  const res = await axios.post(Endpoints.TransactionRequest.Reject, params, config);

  return res;
};

const signApprove = async (params: {
  id: string | number;
  signatures: string[];
  signerAddress: string;
}) => {
  const res = await axios.post(Endpoints.TransactionRequest.SignApprove, params);
  return res;
};

const checkStatus = async (params: { id: string | number }) => {
  const res = await axios.post(Endpoints.TransactionRequest.CheckStatus, params);
  return res;
};

const TransactionRequest = {
  getAll,
  getExport,
  getTransactionOperations,
  getApprovalHistory,
  signApprove,
  reject,
  checkStatus,
};

export default TransactionRequest;
